import { render, staticRenderFns } from "./buffet.vue?vue&type=template&id=49fd2a8e&scoped=true&"
import script from "./buffet.vue?vue&type=script&lang=js&"
export * from "./buffet.vue?vue&type=script&lang=js&"
import style0 from "./buffet.vue?vue&type=style&index=0&id=49fd2a8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fd2a8e",
  null
  
)

export default component.exports